"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Textfield = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 8,
  viewBox: "0 0 16 8"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.937 1H1.063A.837.837 0 0 0 1 1.333v5.334c0 .133.026.251.062.333h13.876A.838.838 0 0 0 15 6.667V1.333A.837.837 0 0 0 14.937 1zm-.023 6.049a.03.03 0 0 0-.006.006.314.314 0 0 0 .008-.014z",
  strokeWidth: 2,
  className: "stroke",
  fill: "none"
}));
var _default = exports.default = Textfield;